"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHomeFolder = getHomeFolder;
exports.makeFolderTree = makeFolderTree;
exports.isFile = isFile;
exports.getFolder = getFolder;
exports.getParentFolderId = getParentFolderId;
exports.getParentFolder = getParentFolder;
exports.getAncestors = getAncestors;
exports.getFilteredByKeyword = getFilteredByKeyword;
exports.getFoldersByPath = getFoldersByPath;

var _immutable = _interopRequireDefault(require("immutable"));

var _I18n = _interopRequireDefault(require("I18n"));

var _stringUtils = require("FileManagerCore/utils/stringUtils");

var _homeFolder = null;

function getHomeFolder() {
  if (_homeFolder) {
    return _homeFolder;
  }

  _homeFolder = _immutable.default.Map({
    name: _I18n.default.text('FileManagerCore.rootFolder'),
    id: null,
    parent_folder_id: null,
    full_path: '',
    children: new _immutable.default.List()
  });
  return _homeFolder;
}

function hasFolderCycle(foldersById, folderToCheck) {
  var ancestors = [];
  var folder = folderToCheck;

  while (folder && folder.parent_folder_id !== null) {
    if (ancestors.indexOf(folder.parent_folder_id) > -1) {
      return true;
    }

    ancestors.push(folder.parent_folder_id);
    folder = foldersById[folder.parent_folder_id];
  }

  return false;
}

function comparator(folderA, folderB) {
  return folderA.name.localeCompare(folderB.name);
}

function makeFolderTree(folders) {
  var foldersById = {};
  folders.forEach(function (folder) {
    var folderWithChildren = folder.toJS();
    folderWithChildren.children = [];
    folderWithChildren.parent = null;
    foldersById[folder.get('id')] = folderWithChildren;
    return foldersById;
  });
  var folderTree = foldersById;
  folders.forEach(function (immutableFolder) {
    var folder = foldersById[immutableFolder.get('id')];
    var parent = foldersById[folder.parent_folder_id];

    if (parent && !hasFolderCycle(foldersById, folder)) {
      parent.children.push(folder);
      folder.parent = parent;
    }
  });
  folderTree = Object.keys(folderTree).map(function (key) {
    return folderTree[key];
  });
  folderTree = folderTree.filter(function (parent) {
    return parent.parent_folder_id === null;
  });
  folderTree.sort(comparator);
  var root = getHomeFolder().toJS();
  root.children = folderTree;
  root.parent = null;
  return root;
}

function isFile(object) {
  return object.has('meta');
}

function getFolder(id, folders) {
  return folders.find(function (folder) {
    return folder.get('id') === id;
  });
}

function getParentFolderId(object) {
  if (!object) {
    return null;
  }

  var folderId = object.get('parent_folder_id') || object.get('folder_id');
  return folderId ? parseInt(folderId, 10) : null;
}

function getParentFolder(object, folders) {
  var parentId = getParentFolderId(object);

  if (!parentId) {
    return getHomeFolder();
  }

  return folders.find(function (folder) {
    return folder.get('id') === parentId;
  });
}

function getAncestors(folder, folders) {
  var ancestors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new _immutable.default.Set();

  if (!folder || !folder.get('parent_folder_id')) {
    return ancestors;
  }

  var parentId = parseInt(folder.get('parent_folder_id'), 10);
  var parentFolder = getFolder(parentId, folders);

  if (ancestors.contains(parentFolder.get('id'))) {
    return ancestors;
  }

  var nextAncestors = ancestors.add(parentFolder.get('id'));
  return getAncestors(parentFolder, folders, nextAncestors);
}

function getFilteredByKeyword(folders, keyword) {
  return folders.filter(function (folder) {
    var folderName = folder.get('name').toLowerCase();
    var searchQuery = keyword.toLowerCase();

    try {
      // decode percent-encoding, which is safe because folder names can't contain %
      searchQuery = window.decodeURIComponent(searchQuery);
    } catch (e) {} // eslint-disable-line no-empty


    return folderName.indexOf(searchQuery) >= 0;
  });
}

function getFoldersByPath(folders, path, keyword) {
  if (keyword) {
    return getFilteredByKeyword(folders, keyword);
  } else if (!path) {
    return folders.filter(function (folder) {
      return folder.get('parent_folder_id') === null;
    });
  }

  var parentFolderFromPath = folders.find(function (folder) {
    return folder.get('full_path') === "/" + path || folder.get('full_path') === path;
  });

  if (parentFolderFromPath) {
    return folders.filter(function (folder) {
      return parseInt(folder.get('parent_folder_id'), 10) === parentFolderFromPath.get('id');
    });
  } // [TEMPORARY FIX] if the parent folder is hidden, use the path and regex
  // which may be less reliable since it won't use the parent_folder_id


  return folders.filter(function (folder) {
    var fullPath = folder.get('full_path');
    var regex = new RegExp("\\/" + (0, _stringUtils.escapeRegExp)(folder.get('name')) + "$");
    var basePath = fullPath.replace(regex, '');
    return basePath === "/" + path;
  });
}